import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { KeySlService } from 'src/app/services/key-sl.service';

@Component({
  selector: 'api-sl-form-rq',
  templateUrl: './api-sl-form-rq.component.html',
  styleUrls: ['./api-sl-form-rq.component.scss'],
})
export class ApiSlFormRqComponent implements OnInit {
  @Input() aviableApis: any;
  @Input() categoryInput: string;
  @Input() valueInput: string;
  @Output() resultEntities = new EventEmitter<any>();
  apiSelect: any;

  goForm: boolean;
  spiner: boolean;
  constructor(
    private readonly fb: FormBuilder,
    public keyKlService: KeySlService
  ) {}
  form;

  'Companies House Search Officers by Phrase' = {
    result: [
      {
        id: '4NztMxn9K4Avn5Re95hj0g57Ldc',
        name: 'Dr Blessing MAFIMISEBI',
        location_info: {
          locality: 'Taunton',
          country: 'England',
          postal_code: 'TA2 7AP',
          address_line_1: 'Cheddon Road',
          premises: '203',
        },
        location: '203 Cheddon Road, Taunton, England, TA2 7AP',
        appointment_count: 1,
        bdate_month: 8,
        bdate_year: 1966,
      },
      {
        id: '5XyT8PqR2WsV1DfG7HjKl0MnBvC',
        name: 'Dr John Doe',
        location_info: {
          locality: 'London',
          country: 'England',
          postal_code: 'SW1A 1AA',
          address_line_1: '10 Downing Street',
          premises: '10',
        },
        location: '10 Downing Street, London, England, SW1A 1AA',
        appointment_count: 3,
        bdate_month: 5,
        bdate_year: 1980,
      },
      {
        id: '6ZqW9XsE2RdF3TgY7HnJk8LpOiU',
        name: 'Dr Jane Smith',
        location_info: {
          locality: 'Manchester',
          country: 'England',
          postal_code: 'M1 1AB',
          address_line_1: 'Oxford Road',
          premises: '25',
        },
        location: '25 Oxford Road, Manchester, England, M1 1AB',
        appointment_count: 5,
        bdate_month: 11,
        bdate_year: 1975,
      },
      {
        id: '7AaB8CcD9EeF0GgHhIiJjKkLlMm',
        name: 'Dr Emily Johnson',
        location_info: {
          locality: 'Birmingham',
          country: 'England',
          postal_code: 'B1 1BB',
          address_line_1: 'New Street',
          premises: '15',
        },
        location: '15 New Street, Birmingham, England, B1 1BB',
        appointment_count: 2,
        bdate_month: 3,
        bdate_year: 1990,
      },
      {
        id: '8NnO9PpQ0RrSsTtUuVvWwXxYyZz',
        name: 'Dr Michael Brown',
        location_info: {
          locality: 'Liverpool',
          country: 'England',
          postal_code: 'L1 1CC',
          address_line_1: 'Waterfront',
          premises: '30',
        },
        location: '30 Waterfront, Liverpool, England, L1 1CC',
        appointment_count: 4,
        bdate_month: 7,
        bdate_year: 1985,
      },
    ],
  };
  truecaller = {
    exec_time: 5.123456789,
    count: 1,
    results: [
      {
        phone: '123456789012',
        national_format: '012 345 6789',
        country_phone_code: 1,
        country_code: 'US',
        operator: 'AT&T',
        name: 'John Doe',
        birthday: 946684800,
        about: 'Some additional info',
        addresses: [
          {
            address: '123 Main St, 12345, New York, US',
            street: '123 Main St',
            zipCode: '12345',
            city: 'New York',
            countryCode: 'US',
            timeZone: '-05:00',
            type: 'address',
          },
        ],
        internet_addresses: [
          {
            id: 'john.doe@gmail.com',
            service: 'email',
            caption: 'John Doe',
            type: 'internetAddress',
          },
          {
            id: 'https://github.com/johndoe',
            service: 'link',
            type: 'internetAddress',
          },
        ],
        links: [
          {
            type: 'maltego.github.profile',
            value: 'johndoe',
            recognized_url: 'https://github.com/johndoe',
          },
        ],
        access: 'PUBLIC',
        spam_info: {},
        comments_count: '',
        company: 'Some Company',
        position: 'Developer',
        photo: 'https://images.example.com/johndoe.jpg',
        gender: 'male',
        tags: [],
      },
      {
        phone: '987654321098',
        national_format: '098 765 4321',
        country_phone_code: 44,
        country_code: 'GB',
        operator: 'Vodafone',
        name: 'Jane Smith',
        birthday: 978307200,
        about: 'More additional info',
        addresses: [
          {
            address: '456 High St, 67890, London, GB',
            street: '456 High St',
            zipCode: '67890',
            city: 'London',
            countryCode: 'GB',
            timeZone: '+00:00',
            type: 'address',
          },
        ],
        internet_addresses: [
          {
            id: 'jane.smith@gmail.com',
            service: 'email',
            caption: 'Jane Smith',
            type: 'internetAddress',
          },
          {
            id: 'https://github.com/janesmith',
            service: 'link',
            type: 'internetAddress',
          },
        ],
        links: [
          {
            type: 'maltego.github.profile',
            value: 'janesmith',
            recognized_url: 'https://github.com/janesmith',
          },
        ],
        access: 'PUBLIC',
        spam_info: {},
        comments_count: '',
        company: 'Another Company',
        position: 'Designer',
        photo: 'https://images.example.com/janesmith.jpg',
        gender: 'female',
        tags: [],
      },
      {
        phone: '555123456789',
        national_format: '055 123 4567',
        country_phone_code: 49,
        country_code: 'DE',
        operator: 'Telekom',
        name: 'Max Mustermann',
        birthday: 1009843200,
        about: 'Additional information',
        addresses: [
          {
            address: '789 Hauptstr, 10115, Berlin, DE',
            street: '789 Hauptstr',
            zipCode: '10115',
            city: 'Berlin',
            countryCode: 'DE',
            timeZone: '+01:00',
            type: 'address',
          },
        ],
        internet_addresses: [
          {
            id: 'max.mustermann@gmail.com',
            service: 'email',
            caption: 'Max Mustermann',
            type: 'internetAddress',
          },
          {
            id: 'https://github.com/maxmustermann',
            service: 'link',
            type: 'internetAddress',
          },
        ],
        links: [
          {
            type: 'maltego.github.profile',
            value: 'maxmustermann',
            recognized_url: 'https://github.com/maxmustermann',
          },
        ],
        access: 'PUBLIC',
        spam_info: {},
        comments_count: '',
        company: 'Tech Corp',
        position: 'Engineer',
        photo: 'https://images.example.com/maxmustermann.jpg',
        gender: 'male',
        tags: [],
      },
      {
        phone: '33123456789',
        national_format: '033 123 4567',
        country_phone_code: 39,
        country_code: 'IT',
        operator: 'TIM',
        name: 'Maria Rossi',
        birthday: 1025481600,
        about: 'Extra information',
        addresses: [
          {
            address: '123 Via Roma, 00100, Rome, IT',
            street: '123 Via Roma',
            zipCode: '00100',
            city: 'Rome',
            countryCode: 'IT',
            timeZone: '+01:00',
            type: 'address',
          },
        ],
        internet_addresses: [
          {
            id: 'maria.rossi@gmail.com',
            service: 'email',
            caption: 'Maria Rossi',
            type: 'internetAddress',
          },
          {
            id: 'https://github.com/mariarossi',
            service: 'link',
            type: 'internetAddress',
          },
        ],
        links: [
          {
            type: 'maltego.github.profile',
            value: 'mariarossi',
            recognized_url: 'https://github.com/mariarossi',
          },
        ],
        access: 'PUBLIC',
        spam_info: {},
        comments_count: '',
        company: 'Design Studio',
        position: 'Artist',
        photo: 'https://images.example.com/mariarossi.jpg',
        gender: 'female',
        tags: [],
      },
      {
        phone: '81312345678',
        national_format: '081 312 3456',
        country_phone_code: 81,
        country_code: 'JP',
        operator: 'NTT',
        name: 'Taro Yamada',
        birthday: 1041379200,
        about: 'Additional details',
        addresses: [
          {
            address: '456 Sakura St, 100-0001, Tokyo, JP',
            street: '456 Sakura St',
            zipCode: '100-0001',
            city: 'Tokyo',
            countryCode: 'JP',
            timeZone: '+09:00',
            type: 'address',
          },
        ],
        internet_addresses: [
          {
            id: 'taro.yamada@gmail.com',
            service: 'email',
            caption: 'Taro Yamada',
            type: 'internetAddress',
          },
          {
            id: 'https://github.com/taroyamada',
            service: 'link',
            type: 'internetAddress',
          },
        ],
        links: [
          {
            type: 'maltego.github.profile',
            value: 'taroyamada',
            recognized_url: 'https://github.com/taroyamada',
          },
        ],
        access: 'PUBLIC',
        spam_info: {},
        comments_count: '',
        company: 'Tech Solutions',
        position: 'Analyst',
        photo: 'https://images.example.com/taroyamada.jpg',
        gender: 'male',
        tags: [],
      },
      {
        phone: '61234567890',
        national_format: '061 234 5678',
        country_phone_code: 61,
        country_code: 'AU',
        operator: 'Telstra',
        name: 'Olivia Brown',
        birthday: 1072915200,
        about: 'More details',
        addresses: [
          {
            address: '789 King St, 2000, Sydney, AU',
            street: '789 King St',
            zipCode: '2000',
            city: 'Sydney',
            countryCode: 'AU',
            timeZone: '+10:00',
            type: 'address',
          },
        ],
        internet_addresses: [
          {
            id: 'olivia.brown@gmail.com',
            service: 'email',
            caption: 'Olivia Brown',
            type: 'internetAddress',
          },
          {
            id: 'https://github.com/oliviabrown',
            service: 'link',
            type: 'internetAddress',
          },
        ],
        links: [
          {
            type: 'maltego.github.profile',
            value: 'oliviabrown',
            recognized_url: 'https://github.com/oliviabrown',
          },
        ],
        access: 'PUBLIC',
        spam_info: {},
        comments_count: '',
        company: 'Creative Agency',
        position: 'Writer',
        photo: 'https://images.example.com/oliviabrown.jpg',
        gender: 'female',
        tags: [],
      },
    ],
  };
  'Facebook Search Users by Different Parameters' = {
    result: [
      {
        type: 'profile',
        id: '1',
        alias: 'zuck',
        name: 'Mark Zuckerberg',
        url: 'https://www.facebook.com/zuck',
        info: [
          'CEO of Meta (formerly Facebook)',
          'Co-founder of Facebook',
          'Harvard University dropout',
        ],
        photo:
          'https://holatelcel.com/wp-content/uploads/2017/03/Marck-Zuckerberg.jpg',
      },
      {
        type: 'profile',
        id: '2',
        alias: 'cristiano',
        name: 'Cristiano Ronaldo',
        url: 'https://www.facebook.com/Cristiano',
        info: [
          'Professional Footballer',
          "5-time Ballon d'Or winner",
          'Al Nassr FC',
        ],
        photo:
          'https://phantom-marca-mx.uecdn.es/55e4120e7b9e262f9ace7a2d5a81c450/resize/660/f/webp/mx/assets/multimedia/imagenes/2025/03/19/17423955596786.jpg',
      },
      {
        type: 'profile',
        id: '3',
        alias: 'william',
        name: 'Will Smith',
        url: 'https://www.facebook.com/WillSmith',
        info: [
          'Actor, Producer, Rapper',
          "Known for 'The Fresh Prince of Bel-Air'",
          'Oscar-winning actor',
        ],
        photo:
          'https://cloud.rtl.it/RTLFM/News/Article/1000x1000/will-smith-i-50-anni-dell-eterno-principe-di-bel-air-tehtb.jpg',
      },
      {
        type: 'profile',
        id: '4',
        alias: 'shakira',
        name: 'Shakira',
        url: 'https://www.facebook.com/shakira',
        info: [
          'Singer, Songwriter',
          "Known for 'Hips Don't Lie'",
          'UNICEF Goodwill Ambassador',
        ],
        photo:
          'https://www.fr.de/assets/images/34/66/34066261-saengerin-shakira-h70.jpg',
      },
      {
        type: 'profile',
        id: '5',
        alias: 'elonmusk',
        name: 'Elon Musk',
        url: 'https://www.facebook.com/elonmusk',
        info: [
          'CEO of Tesla and SpaceX',
          'Co-founder of Neuralink and OpenAI',
          'Richest person in the world (2023)',
        ],
        photo:
          'https://media.cnn.com/api/v1/images/stellar/prod/cnne-1288435-elon-musk-twitter.jpg', // URL ficticia
      },
    ],
  };

  ngOnInit() {}
  goFormClick(apiSelected) {
    this.apiSelect = apiSelected;
    this.goForm = true;
    // Inicializa el FormGroup
    const queryForm = {};

    // Itera sobre las propiedades de apiSelected.params
    for (const key in apiSelected.params) {
      if (key !== 'Authorization') {
        // Descarta Authorization
        const param = apiSelected.params[key];

        // Define las validaciones dinámicamente
        const validators = [];
        const valueFormInput = this.setValueFormInput(key);
        if (param.required) {
          validators.push(Validators.required); // Agrega Validators.required si es requerido
        }

        // Agrega el campo al FormGroup
        queryForm[key] = [valueFormInput, validators];
      }
    }

    // Crea el FormGroup con los campos dinámicos
    this.form = this.fb.group(queryForm);
  }
  getResult() {
    console.log(this.apiSelect);
    this.spiner = true;
    let key = JSON.parse(localStorage.getItem('currentApiKey'));
    this.keyKlService
      .requestApiSocialLink(this.apiSelect._id, this.form.value, key)
      .subscribe((res: any) => {
        console.log(res);

        this.resultEntities.emit({
          entities: res.data,
          apiSelect: this.apiSelect,
        });
        this.spiner = false;
      });

    // let exampleEntities: any;
    // switch (this.apiSelect.descripcion) {
    //   case 'Companies House Search Officers by Phrase':
    //     exampleEntities = this['Companies House Search Officers by Phrase'];
    //     break;
    //   case 'truecaller':
    //     exampleEntities = this.truecaller;
    //     break;
    //   case 'Facebook Search Users by Different Parameters':
    //     exampleEntities = this['Facebook Search Users by Different Parameters'];
    //     break;
    // }
    // setTimeout(() => {
    //   this.resultEntities.emit({
    //     entities: exampleEntities,
    //     apiSelect: this.apiSelect,
    //   });
    //   this.spiner = false;
    // }, 1000);
  }
  getFormKeys() {
    return Object.keys(this.form.controls); // Retorna las llaves del FormGroup
  }
  goBack() {
    this.goForm = false;
    this.form = {};
  }

  setValueFormInput(key) {
    const nameKeys = [
      'first_name',
      'last_name',
      'username',
      'name',
      'alias',
      'person',
      'query',
      'fullname',
    ];
    const companyKeys = ['company_name'];

    if (nameKeys.includes(key) || companyKeys.includes(key)) {
      return this.valueInput;
    } else {
      return '';
    }
  }
}
